export default __webpack_public_path__ + "static/media/angelusband2021.b74d7a31.jpg";